export interface WhatsOnEvent {
  id: string
  title: string
  date: string
  description: string
  imageUrl?: string
  inviteOnly: boolean
  rsvpRequired: boolean
  rsvpStatus?: 'pending' | 'accepted' | 'declined'
  ctaLabel?: string
  ctaUrl?: string
  eventId: 'industry' | 'active' | 'muscle'
}

export const whatsOnEvents: WhatsOnEvent[] = [
  // Dubai Active Industry Events
  {
    id: 'padel-tournament',
    title: 'Padel Tournament',
    date: 'Thursday, 23 October',
    description:
      'Limited slots available. Kickstart the weekend at Rally Padel Club with industry friends. Registration details announcing soon.',
    imageUrl: 'https://a.storyblok.com/f/282702/1000x1000/4feff03437/padel.jpg',
    inviteOnly: true,
    rsvpRequired: true,
    rsvpStatus: 'pending',
    eventId: 'industry',
  },
  {
    id: 'official-pre-opening',
    title: 'Official Pre-Opening',
    date: 'Thursday, 23 October',
    description:
      'Invite-only event welcoming key stakeholders as we announce updates from IEG Middle East, Dubai Active, Dubai Muscle Show and Dubai Active Industry, along with special guests.',
    imageUrl: 'https://a.storyblok.com/f/282702/1000x1000/617c27bce5/roxy.jpg',
    inviteOnly: true,
    rsvpRequired: true,
    rsvpStatus: 'pending',
    eventId: 'industry',
  },
  {
    id: 'icreps-summit',
    title: 'ICREPS Global Standards Summit',
    date: 'Friday, 24 October',
    description:
      'Celebrate the launch of the Global Scope of Practice for Exercise Professionals with esteemed members of ICREPS, followed by a breakfast reception for attendees.',
    imageUrl:
      'https://a.storyblok.com/f/282702/1400x1400/dd06dda5f9/icreps.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    ctaLabel: 'Find out more',
    ctaUrl:
      'https://dubaiactiveindustry.com/summit-series/icreps-global-standards/',
    eventId: 'industry',
  },
  {
    id: 'speed-networking',
    title: 'Speed Networking',
    date: '24 - 25 October',
    description:
      'Exchange business cards with three categories of buyers: Wellness, Retail and Operators. Open to all industry attendees. Apply via our Matchmaking app.',
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/fa1cfaeb5c/speednetworking.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'industry',
  },
  {
    id: 'delegates-lunch',
    title: 'Delegates Lunch',
    date: 'Friday, 24 October',
    description:
      'Exclusive networking lunch for CEO Forum Speakers and Delegates. Included in your CEO Forum ticket.',
    imageUrl:
      'https://a.storyblok.com/f/282702/147x150/77d1e91f9d/theceoforum.svg',
    inviteOnly: true,
    rsvpRequired: true,
    rsvpStatus: 'pending',
    eventId: 'industry',
  },
  {
    id: 'networking-party',
    title: 'Networking Party | Your Personal Training',
    date: 'Friday, 24 October',
    description:
      'Invite only! Enjoy a social gathering with industry friends in the Active Arena, with all-inclusive beverages, food and entertainment.',
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/009b699019/networkingparty.jpg',
    inviteOnly: true,
    rsvpRequired: true,
    rsvpStatus: 'pending',
    eventId: 'industry',
  },

  // Dubai Muscle Show Events
  {
    id: 'dubai-muscle-talks',
    title: 'Dubai Muscle Talks',
    date: '24 - 26 October',
    description:
      'Join engaging Q&A sessions and hear insightful talks with fitness and bodybuilding legends, including Mr.Olympia champions! Discover the secrets to reaching your full potential by gaining insights into their top training methods, nutritional strategies, and mindset techniques.',
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/3a08e088a1/dubai-muscle-talks.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'muscle',
  },
  {
    id: 'dubai-muscle-classic',
    title: 'Dubai Muscle Classic',
    date: '24 - 26 October',
    description:
      "Feast your eyes on the Middle East's biggest bodybuilding competition. In partnership with the IFBB Pro Elite and Emirates Bodybuilding Federation. Over AED70,000 in prize money up for grabs with 17 PRO CARDS!",
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/3dbfb0e97b/dubai-muscle-classic-mens.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'muscle',
  },
  {
    id: 'fmg-international',
    title: 'FMG International',
    date: 'Saturday, 25 October 2025',
    description:
      'Witness Fitness, muscle and glamour on an extraordinary stage, beneath the blazing lights on Saturday, 25th October 2025',
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/c53c211aba/fmginternational.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    ctaLabel: 'Book Tickets',
    ctaUrl:
      'https://tickets.virginmegastore.me/ae/sports/29798/fmg-international-dubai-pro-am',
    eventId: 'muscle',
  },
  {
    id: 'team-nogueira',
    title: 'Team Nogueira Future Champions',
    date: '24 - 26 October',
    description:
      "Spectate back-to-back competitions, challenges and demonstrations showcasing the region's best of Boxing, MMA, Muay Thai and Jiu-Jitsu.",
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/819de1f04f/teamnogeuriafuturechamps.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'muscle',
  },
  {
    id: 'hyrox-365-muscle',
    title: 'HYROX 365 powered by GymNation',
    date: '24 - 26 October',
    description:
      "A condensed, high-octane version of a full HYROX race that blends running and functional fitness into a dynamic community challenge. Whether you're a seasoned HYROX competitor or curious to experience the thrill of HYROX for the first time, this event has something for everyone.",
    imageUrl:
      'https://a.storyblok.com/f/282702/858x623/7588b50b66/hyrox-365.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    ctaLabel: 'Join the challenge',
    ctaUrl: 'https://gymnation.com/hyrox365challenge/',
    eventId: 'muscle',
  },
  {
    id: 'athlete-meet-greet',
    title: 'Athlete Meet & Greet',
    date: '24 - 26 October',
    description:
      'Meet your bodybuilding heroes and fitness legends. Gain exclusive access for autographs, one-on-one interactions and pictures.',
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/791092131f/athlete-meet-greet.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'muscle',
  },
  {
    id: 'the-exhibition-muscle',
    title: 'The Exhibition',
    date: '24 - 26 October',
    description:
      "Pick up 1000's of freebies and explore 350+ of the industry's leading brands including Supplements, Nutrition, Meal Prep, Apparel, Hydration, Gym Equipment, and so much more.",
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/dc8b2434bc/the-exhibition.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'muscle',
  },

  // Dubai Active Show Events
  {
    id: 'active-arena',
    title: 'Active Arena',
    date: '24 - 26 October',
    description:
      "Immerse yourself in the heart-pounding energy of the Active Arena, the epicenter of Dubai Active's fitness universe. Experience electrifying workouts led by headline talent and electric masterclasses, fueling your fitness enthusiasm.",
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x727/27676393f9/active-arena.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'active',
  },
  {
    id: 'main-fitness-stage',
    title: 'Main Fitness Stage',
    date: '24 - 26 October',
    description:
      'An electrifying and dynamic hub in the heart of Dubai Active, where an incredible range of fitness activities and performances collide, igniting the passion of fitness enthusiasts of all levels.',
    imageUrl:
      'https://a.storyblok.com/f/282702/1500x1000/a9c59e2e5f/influencer.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'active',
  },
  {
    id: 'go-sport-battle',
    title: 'GO Sport Battle of the Brands',
    date: '24 - 26 October',
    description:
      'Witness top performance brands go head-to-head in a live pitch showdown for the ultimate prize: a game-changing retail partnership with leading sports retailer, GO Sport.',
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/8cc86d81ad/go-sport-botb.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'active',
  },
  {
    id: 'hyrox-365-active',
    title: 'HYROX 365 powered by GymNation',
    date: '24 - 26 October',
    description:
      "A condensed, high-octane version of a full HYROX race that blends running and functional fitness into a dynamic community challenge. Whether you're a seasoned HYROX competitor or curious to experience the thrill of HYROX for the first time, this event has something for everyone.",
    imageUrl:
      'https://a.storyblok.com/f/282702/858x623/7588b50b66/hyrox-365.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    ctaLabel: 'Join the challenge',
    ctaUrl: 'https://gymnation.com/hyrox365challenge/',
    eventId: 'active',
  },
  {
    id: 'yoga-pilates-studio',
    title: 'Yoga & Pilates Studio',
    date: '24 - 26 October',
    description:
      "Discover tranquility and transformation in Dubai Active's premier Yoga and Pilates Studio, where expert instructors and serene ambiance guide your journey to inner peace and physical well-being.",
    imageUrl:
      'https://a.storyblok.com/f/282702/1500x900/1d7ba73a81/yoga-studio.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'active',
  },
  {
    id: 'dubai-active-talks',
    title: 'Dubai Active Talks',
    date: '24 - 26 October',
    description:
      "A vibrant space hosting Q&A's with headline talent, leading names in fitness as well as experts and practitioners sharing valuable insights and secrets to success. Engage in discussions covering topics such as nutrition, mindfulness, fitness, and mental health, pre-post natal, lifting, and much more.",
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x800/3d8de078ee/dubai-active-talks.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'active',
  },
  {
    id: 'the-exhibition-active',
    title: 'The Exhibition',
    date: '24 - 26 October',
    description:
      "Pick up 1000's of freebies and explore 400+ of the industry's leading brands including Apparel, Nutrition, Meal Prep, Footwear, Hydration, Gym Facilities, Spas, Salons, Technologies, Retreats and so much more.",
    imageUrl:
      'https://a.storyblok.com/f/282702/1000x1000/886cc9521c/theexhibition.jpg',
    inviteOnly: false,
    rsvpRequired: false,
    eventId: 'active',
  },
]
